<template>
  <div v-if="isActive" class="kv-tab-panel" :class="{ 'is-scrollable': scrollable }">
    <slot></slot>
  </div>
</template>

<script>
// Chave de injeção usada no KvTabs (alterada de 'kv-tab-panels' para 'kv-tabs')
const TabsKey = 'kv-tabs';

export default {
  name: 'KvTabPanel',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
  // Inject para acessar o estado compartilhado do KvTabs
  inject: [TabsKey],
  computed: {
    isActive() {
      // Verifica se o valor deste painel é o mesmo da aba ativa no KvTabs
      // Acessa o valor através do objeto reativo injetado: this[TabsKey].activeTab.value
      return this[TabsKey].activeTab.value === this.value;
    },
  },
};
</script>

<style lang="less">
.kv-tab-panel {
  width: 100%;
  margin-top: 20px;

  .kv-tab-panel.is-scrollable {
    height: 100%;
    overflow-y: auto;
  }
}
</style>